export default build =>
    build.query({
        tagTypes: ['allProductCategories'],
        keepUnusedDataFor: 1,
        query(payload) {
           // console.log("payload in get all products",payload)            
            return {
                url: `/product/getAllProductCategories`,
              //  url: `/product/getAllProducts`,
                method: 'GET'              
            };
           
        },
       providesTags: ['allProductCategories']
    })
